const selectClassNames = `
  col-span-1
  form-select
  block
  w-full
  h-7 md:h-9
  md:py-2
  text-xs md:text-base
  font-normal
  bg-white bg-clip-padding bg-no-repeat
  rounded-b-sm
  transition
  ease-in-out
  m-0
  focus:bg-white focus:outline-none
  cursor-pointer
  border-0
  px-2
`

const sectionParentClassNames = (section) => {
  if (section.hasOwnProperty("parent")) {
    return "text-2xs sm:text-xs h-4 my-0 border border-transparent"
  } else {
    return "hidden"
  }
}

const elementOptions = (activeElements, activeElementId, isActive) => {
  return activeElements.map((option, index) => {
    if (index === 0) {
      return (<option value={option.id} key={index} selected={isActive} className="p-0">
        {option.name}
      </option>)
    } else {
      return (<option value={option.id} key={index} selected={isActive && option.id === activeElementId} className="p-0">
        {option.name}
      </option>)
    }
  })
}

function NonActivePulldown({ section, textAboveTheSection, activeElements, activeElementId, onSelect = f => f }){
  return (
    <span className="hover:text-main-blue hover:font-bold hover:underline">
      <p className={sectionParentClassNames(section)}>
        {textAboveTheSection}
      </p>
      <select
        className={selectClassNames + "hover:text-main-blue hover:font-bold"}
        onChange={(e) => onSelect({
          sectionId: section.id,
          elementId: e.target.value === "" ? activeElements.find(e => e.id !== '').id : e.target.value
        })}
      >
        { elementOptions(activeElements, activeElementId, false) }
      </select>
    </span>
  )
}

function ActivePulldown({ section, textAboveTheSection, activeElements, activeElementId, onSelect = f => f }) {
  return (
    <span className="text-main-blue font-bold underline">
      <p className={sectionParentClassNames(section)}>
        {textAboveTheSection}
      </p>
      <select
        className={selectClassNames + "text-main-blue font-bold"}
        onChange={(e) => onSelect({
          sectionId: section.id,
          elementId: e.target.value === "" ? activeElements.find(e => e.id !== '').id : e.target.value
        })}
      >
        { elementOptions(activeElements, activeElementId, true) }
      </select>
    </span>
  )
}

// 学校種別（pathId）の選択状況に応じた項（各節のプルダウン要素）の一覧を返す
const filteredElements = ({ section, pathId }) => {
  if (section.hasOwnProperty("elements")) {
    // sectionDefinition.json で basesNotDisplayed に設定されている項を除外
    return section.elements.filter(element =>
      !element.hasOwnProperty("basesNotDisplayed") || !element.basesNotDisplayed.includes(pathId)
    )
  } else {
    return []
  }
}

function SectionSelectionSelect({ section, textAboveTheSection, isActive, selectedState, onSelect = f => f }) {
  const activeElements = filteredElements({ section: section, pathId: selectedState.pathId })
  if (isActive) {
    return <ActivePulldown
      section={section}
      textAboveTheSection={textAboveTheSection}
      activeElements={activeElements}
      activeElementId={selectedState.elementId}
      onSelect={onSelect}
    />
  } else {
    return <NonActivePulldown
      section={section}
      textAboveTheSection={textAboveTheSection}
      activeElements={activeElements}
      activeElementId={selectedState.elementId}
      onSelect={onSelect}
    />
  }

}

export default SectionSelectionSelect;
